import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { green, grey } from "@mui/material/colors";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Base theme. augmentColor gives the custom colours light / dark /
// contrastText as well, so they work like the built-in palette colours
// (e.g. <Button color="green">). Before, only `main` existed.
const baseTheme = createTheme();
const { augmentColor } = baseTheme.palette;

let theme = createTheme({
  // Default MUI breakpoints: xs 0, sm 600, md 900, lg 1200, xl 1536
  palette: {
    green: augmentColor({ color: { main: green[500] }, name: "green" }),
    grey: {
      // keeps the full grey scale (50...900) and adds `main`
      main: grey[500],
    },
  },
});

// Scales MUI typography variants (h1-h6, body, etc.) down on small screens.
theme = responsiveFontSizes(theme);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* Consistent resets: box-sizing: border-box, body margin 0, and
          font smoothing. Complements the responsive base in App.css. */}
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();